// extracted by mini-css-extract-plugin
export var colorSquare = "_t6-0";
export var danger = "_t6-5";
export var lightPink = "_t6-8";
export var neutralBlue = "_t6-7";
export var neutralYellow = "_t6-6";
export var normal = "_t6-1";
export var primary = "_t6-2";
export var primaryLight = "_t6-3";
export var solidBlack = "_t6-g";
export var solidGreen = "_t6-b";
export var solidLightBlue = "_t6-d";
export var solidNavy = "_t6-c";
export var solidOrange = "_t6-f";
export var solidPink = "_t6-e";
export var solidRed = "_t6-9";
export var solidYellow = "_t6-a";
export var success = "_t6-4";